import { PropsWithChildren } from "react";
import FullscreenModalLayout from "./FullscreenModalLayout";
import CloseButton from "../buttons/CloseButton";

export const QuickViewSection = ({
  title,
  children,
  className
}: PropsWithChildren<{ title?: React.ReactNode; className?: string }>) => (
  <article className="mt-5">
    {title !== undefined && (
      <h2 className="mb-2 text-xl font-medium leading-[150%] text-ctb-blue">
        {title}
      </h2>
    )}
    <span className={className}>{children}</span>
  </article>
);

const QuickViewModal = ({
  title,
  enabled,
  children,
  className,
  onClick
}: PropsWithChildren<{
  title?: React.ReactNode;
  enabled: boolean;
  className?: string;
  onClick: () => void;
}>) => {
  return (
    <>
      {enabled && (
        <FullscreenModalLayout
          containerClassName="!fixed !inset-0 !w-full !h-full"
          className="bg-black/30 backdrop-blur-sm"
          onClick={onClick}
        >
          <section
            className={
              "absolute right-0 h-full w-full animate-slideOutFromRight rounded-s-lg bg-white p-5 shadow-2xl max-md:border-l-2 md:w-[512px] " +
              className
            }
          >
            {title && (
              <h1 className="mb-3 flex justify-between text-2xl font-medium leading-[150%] text-ctb-blue">
                {title}
                <CloseButton iconClassName="mb-1 h-7 w-7" onClick={onClick} />
              </h1>
            )}


            {children}
          </section>
        </FullscreenModalLayout>
      )}
    </>
  );
};

export default QuickViewModal;
